import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface DiscardAllEditsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
}

// Confirmation for discarding every manual edit on the run. Presentational — the
// sidebar owns the mutation and open state and passes them in.
export const DiscardAllEditsDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: DiscardAllEditsDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Discard all edits?</DialogTitle>
        <DialogDescription className="sr-only">
          Confirm discarding every manual edit on this run
        </DialogDescription>
      </DialogHeader>
      <Stack align="start" className="w-full" gap={6}>
        <Text tone="muted">
          This reverts every edited cell to the value the payroll script
          produced and removes every row you added manually.
        </Text>
        <Alert color="warning" role="status">
          <WarningIcon />
          <AlertDescription>
            <Text variant="caption">
              This can&apos;t be undone. Your manual edits and added rows for
              this run will be permanently discarded.
            </Text>
          </AlertDescription>
        </Alert>
      </Stack>
      <DialogFooter>
        <Button
          variant="secondary"
          disabled={isPending}
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
        <Button
          color="danger"
          onClick={onConfirm}
          disabled={isPending}
          loading={isPending}
        >
          Discard all edits
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
